// STEP LIVE-CONSOLE-OVERLAY-COLLAPSE-PIN-1 · 공통 접기/고정 wrapper.
//
// 책임: title · collapsed · pinned · toggle · pin checkbox · children render.
// Overlay business logic 미포함 (지시 §12).  Studio UI mount 금지 (지시 §13).
//
// 접기 = children 을 `hidden` 으로 숨기기만 함 — 자식 컴포넌트는 그대로
// 마운트 상태 유지 (타이머 · QR 등 내부 state preservation · 지시 §10/§11).
//
// 사용 패턴:
//   <CollapsibleControlSection
//      panelKey="position"
//      title="위치"
//      collapsed={collapsed}
//      pinned={pinned}
//      onToggle={() => toggle('position')}
//      onPin={(v) => setPinned('position', v)}
//      testIdPrefix="overlay-position"
//      extraHeader={null}>  {/* 선택: title 옆에 helper text 추가 */}
//      {/* existing panel content */}
//   </CollapsibleControlSection>
import React from 'react';

export default function CollapsibleControlSection({
  panelKey,
  title,
  collapsed,
  pinned,
  onToggle,
  onPin,
  testIdPrefix,
  headerExtra = null,
  disabledToggle = false,
  children,
}) {
  const _collapsed = !!collapsed && !pinned;   // normalize: pinned → expanded
  const _toggleDisabled = !!disabledToggle || !!pinned;
  const chevron = _collapsed ? '∨' : '∧';

  return (
    <div
      data-collapsible-panel={panelKey}
      data-collapsed={_collapsed ? 'true' : 'false'}
      data-pinned={pinned ? 'true' : 'false'}
    >
      <div className="flex items-center gap-2 mb-1.5 flex-wrap"
           data-testid={`${testIdPrefix}-collapse-header`}>
        <button type="button"
                onClick={() => { if (!_toggleDisabled) onToggle(); }}
                disabled={_toggleDisabled}
                aria-expanded={!_collapsed}
                aria-controls={`${testIdPrefix}-collapse-body`}
                className="inline-flex items-center gap-1.5 text-[11px] font-black tracking-widest uppercase text-gray-700 dark:text-gray-200 hover:text-black dark:hover:text-white disabled:cursor-not-allowed disabled:opacity-80 min-h-[28px] px-1"
                data-testid={`${testIdPrefix}-collapse-toggle`}>
          <span>{title}</span>
          <span aria-hidden="true" className="text-xs">{chevron}</span>
        </button>
        {headerExtra ? (
          <div className="flex-1 min-w-0 flex items-center gap-2 flex-wrap">
            {headerExtra}
          </div>
        ) : <span className="flex-1" />}
        <label className="inline-flex items-center gap-1 text-[10px] text-gray-600 dark:text-gray-300 cursor-pointer select-none min-h-[28px] px-1"
               data-testid={`${testIdPrefix}-pin-label`}>
          <input type="checkbox"
                 checked={!!pinned}
                 onChange={(e) => onPin(e.target.checked)}
                 data-testid={`${testIdPrefix}-pin-checkbox`}
                 className="h-3 w-3 cursor-pointer" />
          <span>고정</span>
        </label>
      </div>
      <div id={`${testIdPrefix}-collapse-body`}
           hidden={_collapsed}
           aria-hidden={_collapsed ? 'true' : 'false'}
           data-testid={`${testIdPrefix}-collapse-body`}>
        {children}
      </div>
    </div>
  );
}
